import { Box, Typography } from '@mui/material';
import InformationBox from '../../../../components/other/informationBox';
import AgyleButton from '../../../../components/ui/buttons/agyleButton';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import OrganizationAutocomplete from './components/inputs/organizationAutocomplete';
import OrganizationSelectedBox from './components/inputs/organizationSelectedBox';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: 112,
    },
}));

const PrescriptionOrganization = ({ value, handleChange, disabled }) => {
    const { t } = useTranslation();
    const classes = useStyles();

    const [showSelector, setShowSelector] = useState(!!value);
    const [organization, setOrganization] = useState(null);

    const onClear = () => {
        setOrganization(null);
        setShowSelector(false);
        handleChangeValue(null);
    };

    const handleChangeValue = (value) => {
        // Prevent changes if form is disabled
        if (disabled) return;

        handleChange((prev) => ({
            ...prev,
            organization: value,
        }));
    };

    useEffect(() => {
        if (!!value) {
            setOrganization(value);
        }
    }, [value]);

    return (
        <>
            <div className={classes.root}>
                {organization && <OrganizationSelectedBox organization={organization} onChange={onClear} disabled={disabled} />}
                {showSelector && !organization && (
                    <OrganizationAutocomplete
                        value={organization}
                        handleChangeValue={handleChangeValue}
                        onClose={() => setShowSelector(false)}
                        disabled={disabled}
                    />
                )}
                {!showSelector && (
                    <InformationBox type="info" style={{ marginTop: 0 }}>
                        <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography>
                                {t('You can optionally select the organization or pharmacy where this prescription will be fulfilled.')}
                            </Typography>
                            <div>
                                <AgyleButton onClick={() => setShowSelector(true)} disabled={disabled}>
                                    {t('Show')}
                                </AgyleButton>
                            </div>
                        </Box>
                    </InformationBox>
                )}
            </div>
        </>
    );
};

export default PrescriptionOrganization;
